var _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponent5911(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_59_11",
    "data-name": "Component 59 \\u2013 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_276",
    "data-name": "Ellipse 276",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#b6be34"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_277",
    "data-name": "Ellipse 277",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(32 32)",
    fill: "#f7fcff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent5911);
export default __webpack_public_path__ + "static/media/Component 59 – 11.abe4faa069a539348ea8566edee17094.svg";
export { ForwardRef as ReactComponent };